import { theme } from '@agentisai/design-system';

export const muted = {
  color: theme.color.neutral.faint,
  fontSize: theme.typography.fontSize.bodySm,
};

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

/** One entry per non-blank line — the editor's shape for regex and tag lists. */
export function lines(text: string): string[] {
  return text
    .split('\n')
    .map((l) => l.trim())
    .filter(Boolean);
}
